import Messages from "./../../library/Messages";
import Forms from "./../Forms";

export default class Checkout {
	constructor() {
		this.instance = self;
	}

	static init() {
		if (
			document.body.classList.contains("layout-one-page-checkout") ||
			document.querySelector("[data-one-page-checkout]")
		) {
			return;
		}

		const self = new Checkout();
		self.attachEvents();
		self.removeApprovalToken();
	}

	removeApprovalToken() {
		if (window.location.pathname.indexOf("/checkout/pay/") === -1) {
			return;
		}

		const url = new URL(window.location.href);

		if (url.searchParams.has("token")) {
			url.searchParams.delete("token");
			window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
		}
	}

	attachEvents() {
		const self = this;

		if (document.body.classList.contains("layout-one-page-checkout") || document.querySelector("[data-one-page-checkout]")) {
			return;
		}

		$(window).on("load", function () {
			self.setBackgroundLeftPosition();
		});

		$(window).on("resize", function () {
			self.setBackgroundLeftPosition();
		});

		$(document).on("change", ".js-toggle-billing-address", function () {
			if ($(this).is(":checked")) {
				$(".checkout-billing").slideDown();
			} else {
				$(".checkout-billing").slideUp();
			}
		});

		$(document).on("change", ".js-toggle-trim", function () {

			// could probably be tidied to be:
			// self.applyUnappliedTrimPrice($('.js-toggle-trim').is(':checked'))
			// then just use the true/false value if checked or not

			if($('.js-toggle-trim').is(':checked')) {
				self.applyUnappliedTrimPrice('0');
			} else {
				self.applyUnappliedTrimPrice('1');
			}
		});

		$(document).on("change", ".js-toggle-delivery-address", function () {
			if ($(this).is(":checked")) {
				$(".checkout-delivery").slideDown();
			} else {
				$(".checkout-delivery").slideUp();
			}
		});

		$(document).on("change", ".js-toggle-delivery-collection", function () {
			if ($(this).val() == "deliver") {
				$(".checkout-billing-different").slideDown();
				$(".js-toggle-billing-address").prop("checked", false);
				$(".checkout-delivery").slideDown();

				if (!$(".js-toggle-billing-address").is(":checked")) {
					$(".checkout-billing").slideUp();
				}
			} else {
				$(".checkout-delivery").slideUp();
				$(".checkout-billing-different").slideUp();
				$(".checkout-billing").slideDown();
				$(".js-toggle-billing-address").prop("checked", true);
			}
		});

		$(document).on("change", ".js-toggle-checkout-login", function () {
			if ($(this).val() == 1) {
				$(".checkout-login").slideDown();
				$(".checkout-personal").slideUp();
			} else {
				$(".checkout-login").slideUp();
				$(".checkout-personal").slideDown();
			}
		});

		$(document).on("click", ".js-show-checkout-delivery-new", function (e) {
			e.preventDefault();
			$(".checkout-delivery-new").slideDown();
		});

		$(document).on("change", ".js-toggle-card-details", function (e) {
			let toggle = $(this).data("toggle"),
				$cardDetails = $(".checkout-card-details");

			if (toggle == "show") {
				$cardDetails.slideDown();
			} else {
				$cardDetails.slideUp();
			}
		});

		$(document).on("submit", ".js-on-submit-add-promocode", function (e) {
			e.preventDefault();
			const $button = $(this).find("button[type='submit']");
			//$button.find(".btn-text").hide();
			$button.find(".btn-spinner").show();
			$button.css("pointer-events", "none");
			$button.attr("disabled", "disabled");
			self.applyPromoCode($(this));
		});

		$(document).on("click", ".js-on-click-remove-promocode", function (e) {
			e.preventDefault();
			self.removePromoCode();
		});

		$(document).on("change", ".js-on-change-dispatch-option", function () {
			self.setChangeDispatchOptions($(this).val());
		});

		$(document).on("change", ".js-on-change-set-delivery", function (e) {
			self.setDelivery($(this).val());
		});

		$(document).on("change", ".js-toggle-gift-card-payments", function (e) {
			e.preventDefault();

			if ($(this).is(":checked")) {
				$(".gift-card-payments").slideDown(200);
			} else {
				$(".gift-card-payments").slideUp(200);
			}
		});

		$(document).on("submit", ".js-add-gift-card-to-basket", function (e) {
			e.preventDefault();
			self.addGiftCardToBasket($(this));
		});

		$(document).on(
			"click",
			".js-remove-gift-card-from-basket",
			function (e) {
				e.preventDefault();
				self.removeGiftCardToBasket($(this).data("gift-card-id"));
			}
		);
	}

	setBackgroundLeftPosition() {
		const self = this,
			$content = $(".js-background-content"),
			$background = $(".js-background"),
			topPos = $content.length > 0 ? $content.offset().top : 0,
			leftPos = $content.length > 0 ? $content.offset().left : 0;

		if ($(".js-background-content").length > 0) {
			$background.css({
				top: topPos,
				left: leftPos,
			});
		}
	}

	applyUnappliedTrimPrice(checkValue) {

		const self = this;

		var applyTrimsAndEmbroidery = checkValue;
		let formData = {};
		formData['customer_apply_trims_and_embroidery'] = applyTrimsAndEmbroidery;

		oc.progressBar.show();

		oc.ajax("shopBasket::onAddUnappliedTrimPrice", {
			data: formData,
			update: { "checkout/basket": ".js-basket" },
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);

				oc.progressBar.hide();

				self.refreshPayments();

				if (data.response === "success") {
					console.log(data);

					$(".js-basket-price").text(
						data.basket_currency_symbol +
							parseFloat(
								data.basket_subtotal_minus_discount_inc_vat
							).toFixed(2)
					);
				} else {
					Messages.error(
						data.message
							? data.message
							: "Sorry, cant get price"
					);
				}
			},
		});
	}

	applyPromoCode($form) {
		const self = this;

		let formData = {};

		$.each($form.serializeArray(), function (key, field) {
			formData[field.name] = field.value;
		});

		oc.progressBar.show();

		oc.ajax("shopBasket::onAddPromoCode", {
			data: formData,
			update: { "checkout/basket": ".js-basket" },
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);

				oc.progressBar.hide();

				self.refreshPayments();

				$(".js-gift-card-error-message").hide();

				if (data.response === "success") {
					$(".js-basket-price").text(
						data.basket_currency_symbol +
							parseFloat(
								data.basket_subtotal_minus_discount_inc_vat
							).toFixed(2)
					);
				} else if (data.response === "matches-giftcard") {
					$(".js-gift-card-error-message").show();
				} else {
					Messages.error(
						data.message
							? data.message
							: "Sorry, this promo code is not recognized"
					);
				}
			},
		});
	}

	removePromoCode() {
		const self = this;

		oc.progressBar.show();

		oc.ajax("shopBasket::onRemovePromoCode", {
			update: { "checkout/basket": ".js-basket" },
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);

				oc.progressBar.hide();

				self.refreshPayments();

				if (data.response == "success") {
					$(".js-basket-price").text(
						data.basket_currency_symbol +
							parseFloat(
								data.basket_subtotal_minus_discount_inc_vat
							).toFixed(2)
					);
				}
			},
		});
	}

	refreshPayments() {
		const self = this,
			$payments = $(".js-payments");

		if ($payments.length > 0) {
			oc.progressBar.show();

			oc.ajax("payments::onRefresh", {
				update: { "payments/default": ".js-payments" },
				success: function (data, responseCode, xhr) {
					this.success(data, responseCode, xhr);

					oc.progressBar.hide();

					Forms.setResolutionInputs();
				},
			});
		}
	}

	setChangeDispatchOptions(val) {
		const self = this;

		oc.progressBar.show();

		oc.ajax("shopOrder::onSetDispatchOption", {
			data: { option_id: val },
			update: { "shopDeliveryOptions/default": ".js-delivery-options" },
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);

				// Ensure the delivery options partial is fully refreshed from
				// the Order component after changing dispatch mode.
				oc.ajax("shopOrder::onLoadDeliveryOptions", {
					update: { "shopDeliveryOptions/default": ".js-delivery-options" },
					success: function (data, responseCode, xhr) {
						this.success(data, responseCode, xhr);

						oc.ajax("shopBasket::onLoad", {
							update: { "checkout/basket": ".js-basket" },
							success: function (data, responseCode, xhr) {
								this.success(data, responseCode, xhr);

								oc.progressBar.hide();
							},
						});
					},
				});
			},
		});
	}

	setDelivery(val) {
		const self = this;

		oc.progressBar.show();

		oc.ajax("shopBasket::onSetDeliveryOption", {
			data: { option_id: val },
			update: { "checkout/basket": ".js-basket" },
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);

				oc.progressBar.hide();
			},
		});
	}

	refreshGiftCardAndBasket() {
		const self = this;

		oc.ajax("shopBasket::onLoad", {
			update: {
				"checkout/gift-cards-applied": ".js-gift-cards-applied",
				"checkout/basket": ".js-basket",
			},
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);

				self.toggleGiftCardSkipPayment(data.basket_total);
			},
		});
	}

	addGiftCardToBasket($form) {
		const self = this,
			$code = $form.find('[name="code"]');

		oc.progressBar.show();

		oc.ajax("shopBasket::onAddGiftCard", {
			data: { code: $code.val() },
			update: {
				"checkout/gift-cards-applied": ".js-gift-cards-applied",
				"checkout/basket": ".js-basket",
			},
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);

				oc.progressBar.hide();

				$code.val("");

				Messages.success("Gift card applied");

				self.toggleGiftCardSkipPayment(data.basket_total);
			},
			error: function (data, responseCode, xhr) {
				let errorMessage = (data && typeof data === 'object' && data.X_OCTOBER_ERROR_MESSAGE)
					? data.X_OCTOBER_ERROR_MESSAGE
					: (typeof data === 'string' ? data : 'An unknown error has occurred, please try again');

				Messages.error(errorMessage);

				oc.progressBar.hide();
			},
		});
	}

	removeGiftCardToBasket(id) {
		const self = this;

		oc.progressBar.show();

		oc.ajax("shopBasket::onRemoveGiftCard", {
			data: { id: id },
			update: {
				"checkout/gift-cards-applied": ".js-gift-cards-applied",
				"checkout/basket": ".js-basket",
			},
			success: function (data, responseCode, xhr) {
				this.success(data, responseCode, xhr);

				oc.progressBar.hide();

				Messages.success("Gift card removed");

				self.toggleGiftCardSkipPayment(data.basket_total);
			},
			error: function (data, responseCode, xhr) {
				let errorMessage = (data && typeof data === 'object' && data.X_OCTOBER_ERROR_MESSAGE)
					? data.X_OCTOBER_ERROR_MESSAGE
					: (typeof data === 'string' ? data : 'An unknown error has occurred, please try again');

				Messages.error(errorMessage);

				oc.progressBar.hide();
			},
		});
	}

	toggleGiftCardSkipPayment(total) {
		const self = this;

		console.log(total);

		if (total >= 0.02) {
			$(".gift-card-payments-complete-order").slideUp(200);
			$(".payment-form-container").slideDown(200);
			$(".payment-form-container").children(":not(.mod-gift-card):not(script):not(style)").slideDown(200);
			$(".checkout-payment-option:not(.mod-gift-card)").slideDown(200);
		} else {
			$(".gift-card-payments-complete-order").slideDown(200);
			$(".payment-form-container").children(":not(.mod-gift-card):not(script):not(style)").slideUp(200);
			$(".checkout-payment-option:not(.mod-gift-card)").slideUp(200);
		}
	}
}
